<template>
  <div class="guess_like">
    <div class="guess_like_title">- 猜你喜欢 -</div>
    <ul class="guess_like_list">
      <li class="guess_like_item" v-for="(item,index) in listData" :key="index" @click="toDetail(item.id)">
        <div class="img_box">
          <img :src="item.pic" alt="">
        </div>
        <p class="guess_like_name">{{item.name}}</p>
        <div class="guess_like_val">
          <span v-if="item.is_deduction===1"><span class="num">{{item.integral}}</span>积分</span>
          <span v-if="item.is_deduction===1&&item.preferential_price>0" class="add">+</span>
          <span v-if="item.preferential_price>0">￥<span class="num">{{item.preferential_price}}</span></span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'guessLike',
  props: {
    id: {
      default: ''
    }
  },
  data () {
    return {
      listData: [] // 猜你喜欢数据
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      console.log(this.id, '猜你喜欢id')
      this.axios(this.$API.GET_GOODS_LIKES, {
        params: {
          id: this.id
        }
      }).then(res => {
        if (res.data.code === 1) {
          this.listData = res.data.data
        } else {
          this.$toast(res.data.msg)
        }
      })
    },
    toDetail (id) {
      this.$router.push({
        path: '/goods',
        query: { id: id }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.guess_like{
  font-family: PingFang HK, PingFang HK-Regular;
  .guess_like_title{
    text-align: center;
    color: #2b2b2b;
    font-weight: bold;
    font-size: 32px;
    margin-bottom: 16px;
  }
  .guess_like_list{
    display: flex;
    flex-wrap: wrap;
    .guess_like_item{
      width: 340px;
      height: 498px;
      padding: 24px 24px;
      background: #ffffff;
      border-radius: 16px;
      margin-bottom: 24px;
      &:nth-of-type(odd){
        margin-right: 22px;
      }
      .img_box{
        width: 292px;
        height: 292px;
        margin-bottom: 8px;
      }
      .guess_like_name{
        font-size: 28px;
        color: #2b2b2b;
        height: 76px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 16px;
      }
      .guess_like_val{
        font-size: 24px;
        color: #e40505;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .num{
          font-size: 32px;
          font-weight: bold;
          margin-right: 4px;
        }
        .add{
          font-size: 32px;
          font-weight: bold;
        }
      }
    }
  }
}

</style>
